/**
 * RootPage — что показывать на корне сайта.
 *
 * Гостю — лендинг (витрина Рублокса), вошедшему — кабинет. Раньше
 * лендинг показывался всем: человек, который уже зарегистрировался и
 * зашёл поиграть, каждый раз упирался в рекламу продукта, которым уже
 * пользуется, и должен был искать вход в кабинет.
 *
 * Приём из школы: там корень так же раздваивается, а витрина остаётся
 * доступной по отдельному адресу `/welcome` — чтобы вошедший мог на неё
 * вернуться (посмотреть, что нового, показать друзьям).
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import HomePage from "./HomePage";

export default function RootPage() {
  const { isAuthenticated, initializing } = useAuth();

  /* Пока проверяется сессия — не рендерим ничего.
     Иначе вошедшему на долю секунды мелькает лендинг, будто его
     разлогинило. Пустой экран честнее мигания. */
  if (initializing) return null;

  if (isAuthenticated) return <Navigate to="/app" replace />;

  return <HomePage />;
}
